import React from 'react'

const Button = React.forwardRef(({children, href, onClick}, ref)=>{
    if(href){
        return <a ref={ref} href={href} className="btn-main" onClick={onClick} data-name={children}>{children} <span></span></a>; 
    }else{
        return <button ref={ref} className="btn-main" onClick={onClick} data-name={children}>{children} <span></span></button>  
    }
})

export default Button;
 